const resources = {
    gotIt: 'Compris'
};

module.exports = function getResource(label, vars = []) {
    return resources[label];
};
